// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { bellOn16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { Icon, registerIcon } from '../icon-base';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-bell-on': IconBellOn;
    }
}

/**
 * The icon component for the 'bellOn' icon
 */
export class IconBellOn extends Icon {
    public constructor() {
        super(bellOn16X16);
    }
}

registerIcon('icon-bell-on', IconBellOn);
export const iconBellOnTag = 'nimble-icon-bell-on';
